import React from 'react'

import { Product } from '../../logic/catalog'

interface Props {
  className?: string
  compact?: boolean
  parameters: Record<string, string>
  product: Product
}

const CartItemParameters = ({
  compact,
  product,
  parameters,
  className,
}: Props) => {
  if (Object.values(parameters).length === 0) {
    return null
  }

  return (
    <ul className={className}>
      {Object.entries(parameters).map(([parameterId, value]) => {
        const parameter = product.parameters?.find(
          ({ id }) => id === parameterId,
        )
        const option = parameter?.options.find(({ id }) => id === value)
        if (!parameter || !option) {
          return null
        }
        const title = parameter.title
        return (
          <li key={parameterId}>
            {compact || !title ? '' : `${title}: `}
            {option.displayName}
          </li>
        )
      })}
    </ul>
  )
}

export default CartItemParameters
